const updateSelectAllStatus = () => {
  const tenantsCheckboxes = document.querySelectorAll('input[type="checkbox"][name="report-tenants"]');
  const allCheckbox = document.querySelector('input.select-all-tenant-checkbox[type="checkbox"]');
  const checkboxesNumber = [...tenantsCheckboxes].filter(e => !e.hasAttribute('disabled')).length;
  const checkedCheckboxesNumber = [...tenantsCheckboxes].filter(e => !e.hasAttribute('disabled') && e.checked).length;
  allCheckbox.checked = false;
  allCheckbox.indeterminate = false;
  if (checkedCheckboxesNumber === checkboxesNumber) {
    allCheckbox.checked = true;
  } else if (checkedCheckboxesNumber > 0 && checkedCheckboxesNumber < checkboxesNumber) {
    allCheckbox.indeterminate = true;
  }
};

$(document).on('change', 'input[name=report-type]', function updateTenants() {
  /* Dates are not used for the patient report type, so we hide them if selected */
  const report_type = $(this).val();
  if (report_type === 'patient') {
    $('input#report-start_date').parent().parent().hide();
  } else {
    $('input#report-start_date').parent().parent().show();
  }

  /* The field labels option is only used by the full report */
  if (report_type === 'full') {
    $('#report-labels-group').show();
  } else {
    $('#report-labels-group').hide();
    $('input[name=report-labels]').prop('checked', false);
  }

  /* Manage the tenants display */
  const tenants = $(this).data('tenants');
  if (!tenants) {
    return;
  }

  $('input[name=report-tenants]').each(function showHideTenants() {
    if (tenants.includes($(this).val())) {
      $(this).closest('.checkbox input').prop('disabled', false);
    } else {
      $(this).closest('.checkbox input').prop('disabled', true);
      $(this).prop('checked', false);
    }
  });
  updateSelectAllStatus();
});

export function initializeReportTypeSelection() {
  // A report type may already be checked on load (e.g. pre-selected via a query
  // parameter): re-run the 'change' handler so its tenants/dates/labels are applied.
  $('input[name=report-type]:checked').trigger('change');
}

export function setupReportTenantSelectAll() {
  const allCheckbox = document.querySelector('input.select-all-tenant-checkbox[type="checkbox"]');
  const tenantsCheckboxes = document.querySelectorAll('input[type="checkbox"][name="report-tenants"]');
  document.querySelectorAll('input[type="checkbox"][name="report-tenants"]').forEach(tenantCheckbox => {
    tenantCheckbox.addEventListener('change', updateSelectAllStatus);
  });
  if (allCheckbox) {
    allCheckbox.addEventListener('click', () => {
      tenantsCheckboxes.forEach(checkbox => {
        if (!checkbox.hasAttribute('disabled')) {
          checkbox.checked = allCheckbox.checked;
        }
      });
    });
  }
}
